
<div class="layout-wrapper" [ngClass]="containerClass">
  <!-- Top-bar for showing left-menu, user information, and plant chosen -->
  <app-top-bar></app-top-bar>

  <div class="layout-sidebar">
    <app-left-menu></app-left-menu>
</div>
<div class="layout-main-container">
  <div class="layout-main">
      <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
       
  
</div>